<template>
    <li class="c-thumbnail-list__item c-thumbnail-list__item-5">
        <a :href="item.url">
            <div class="c-thumbnail-list__img">
                <webp-picture :webp="item.thumbnail_webp_path" class="inherit">
                    <img :src="item.thumbnail_path" alt="">
                </webp-picture>
            </div>
        </a>
        <div class="c-thumbnail-list__text">
            <div class="c-thumbnail-list__text-top">
                <div class="c-thumbnail-list__icon">
                    <div class="c-label is-new" v-if="item.is_new == true">New</div>
                    <div class="c-label is-photos">{{ item.category }}</div>
                    <div class="c-label is-limited" v-if="item.with_extra == true">限定特典付</div>
                </div>
            </div>
            <p class="c-thumbnail-list__booktitle"><a :href="item.url">{{ item.item_title }}</a></p>
            <p class="c-thumbnail-list__bookname" v-for="(talent, i) in item.talents" :key="`first-${i}`">
                <a v-if="talent.id" :href="route(route_list, 'site.talent.detail', {model_id: talent.id, model_name: talent.name})">{{ talent.name }}</a>
                <a v-else tabindex="-1" style="pointer-events:none">{{ talent.name }}</a>
            </p>
            <p v-if="item.has_discount == false" class="c-thumbnail-list__price c-black">
                <span class="u-bold">￥{{ item.item_price }}</span>（税込）
            </p>
            <p v-else class="c-thumbnail-list__price">
                <span class="u-bold">￥{{ item.item_price }}</span>（税込）
                <span class="c-label-off">{{ item.item_discount_detail }}</span>
            </p>
            <p class="c-thumbnail-list__lead" v-html="item.description"></p>
            <div class="profile_list">
                <p class="c-thumbnail-list__publish-date"><span>発売日</span><span>：</span><span>{{ formatDate(item.sale_start_date || item.dsp_start_date)}}</span></p>
                <p class="c-thumbnail-list__publisher" v-if="item.publisher && item.publisher.PUBLISHER"><span>出版社</span><span>：</span><span>{{ item.publisher.PUBLISHER }}</span></p>
                <p class="c-thumbnail-list__series" v-if="item.label_name"><span>レーベル名</span><span>：</span><span>{{ item.label_name }}</span></p>
                <p v-if="item.series_names.length >= 1"  class="c-thumbnail-list__series series_name">
                    <span>シリーズ名</span>
                    <span>：</span>
                    <span v-html="item.series_names.join('<br>')"></span>
                </p>
                <template v-for="(creater, i) in item.creaters" :key="`fourth-${i}`">
                    <p class="c-thumbnail-list__photograph"  v-if="creater.CREATER_DSCRIPTION_CATEGORY === '撮影'">
                        <span>撮影</span><span>：</span><span><a :href="route(route_list, 'site.search.index', {'keyword': creater.CREATER_NAME})">{{ creater.CREATER_NAME }}</a></span>
                    </p>
                </template>
                <p v-if="item.page_num != null" class="c-thumbnail-list__page"><span>ページ数</span><span>：</span><span>{{ item.page_num }}P</span></p>

            </div>
        </div>
        <div v-if="item.web_free_url != null" class="c-btn-trial">
            <a :href="item.web_free_url" target="_blank">立ち読み</a>
        </div>
    </li>
</template>

<script>
    import routeMixin from '../../mixins/route.js';
    import moment from 'moment';

    export default {
        props: [
            'route_list',
            'item',
        ],
        mixins: [routeMixin],
        data() {
            return {
            }
        },
        methods: {
            // 商品価格を3桁区切り
            formatPrice(price) {
                const formatter = new Intl.NumberFormat('ja-JP');
                return formatter.format(price);
            },
            // 日付をmoment プラグインを使って整える
            formatDate(date) {
                if (!date) return '';
                return moment(date).format('YYYY/MM/DD');
            },
        },

    }
</script>

<style lang="scss" scoped>
.c-thumbnail-list__booktitle,
.series_name {
    word-break: break-all;
}
</style>
